import { render } from "./Price.vue?vue&type=template&id=20c348b6"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"
script.render = render

export default script